import { NgModule } from '@angular/core';
import { ComponentsModule } from '../../components/components.module';
import { CommonModule } from '@angular/common';  
import { BrowserModule } from '@angular/platform-browser';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { HistoryComponent } from './history.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
    declarations:[
        HistoryComponent
    ],
    imports:[
        ComponentsModule,
        AngularFontAwesomeModule,
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports:[
        HistoryComponent
    ]
})
export class HistoryModule {}

 // required for AOT compilation
 export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }